<script lang="ts" setup>
	export type FormStepperContext = {
		[id: string]: {
			close?: boolean
			key: string
		}
	}
	defineProps<{
		stepsData: FormStepperContext
	}>()

	const toggleChild = (arg: FormStepperContext[string]) => {
		arg.close = !arg.close
	}
</script>

<template>
	<div data-id="form-stepper">
		<div v-for="(value, key, index) in stepsData" :key="value.key" class="step relative">
			<div class="flex cursor-pointer items-center" @click="toggleChild(value)">
				<h3 class="font-medium capitalize text-gray-700 md:text-lg">
					{{ index + 1 }}.
					{{ key }}
				</h3>
			</div>

			<div
				class="my-3 overflow-y-auto px-2 transition-[1s] ease-in-out sm:px-5"
				:class="{
					'max-h-0': value.close,
					'max-h-[310px]': !value.close
				}"
			>
				<slot :key="value.key" :content="value" :index="index" />
				<slot :name="`cell(${value.key})`" />
			</div>
		</div>
	</div>
</template>
